export default 'statsPage';
